import { render, staticRenderFns } from "./create-group.vue?vue&type=template&id=8ba844da&scoped=true"
import script from "./create-group.vue?vue&type=script&lang=ts"
export * from "./create-group.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba844da",
  null
  
)

export default component.exports